<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#charging-station-page {
        position: absolute;
        right: 1rem;
        top: 6rem;
        background: #FFFFFF;
        width: 100%;
        max-width: 500px;
        border-radius: 0.5rem;
        padding: 1rem;
        box-shadow: 0 0 #000000, 0 0 #000000, 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1);

        div.close-block {
            top: 0.5rem;
            right: 0.5rem;
            position: absolute;

            a.close-block-button {
                justify-content: center;
                align-items: center;
                display: inline-flex;

                border-radius: 0.375rem;
                outline: 2px solid transparent;
                outline-offset: 2px;
                color: rgb(156, 163, 175);
                padding: 0.5rem;

                svg {
                    width: 1.5rem;
                    height: 1.5rem;
                }

                &:hover {
                    background-color: rgb(243, 244, 246);
                    color: rgb(107, 114, 128);
                }
            }
        }

        h2.charging-station-title {
            color: #342C0C;
            font-size: 16px;
            line-height: 20px;
            width: 85%;
            margin: 10px auto 10px;
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            text-align: center;
        }

        div.charging-station-image {
            position: relative;

            img.station-image {
                width: 100%;
                height: 230px;
                object-fit: cover;
                object-position: center;
                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
                border-radius: 5px;
            }

            div.maximize {
                position: absolute;
                right: 4px;
                top: 4px;
                z-index: 2;
                transition: all 0.3s ease-in-out;
                cursor: pointer;

                span.show-icon {
                    display: inline-block;
                    background-color: #ffffff;
                    padding: 9px;
                    border-radius: 50%;

                    img {
                        color: white;
                        display: table-cell;
                        vertical-align: middle;
                        text-align: center;
                        text-decoration: none;
                        height: 14px;
                        width: 14px;
                    }
                }

                &:hover {
                    transform: scale(1.1);
                }
            }

            div.features {
                position: absolute;
                right: 3px;
                bottom: 3px;
                z-index: 2;

                span.source {
                    background-color: #fff;
                    border: 1px solid #ededed;
                    border-radius: 15px;
                    clear: left;
                    color: #000;
                    font-size: 10px;
                    padding: 4px 12px;
                }
            }
        }

        span.navigate-button-group {
            position: relative;
            display: block;
            /*display: inline-block;*/
            margin-top: 20px;

            &.open > .navigation-button-dropdown-menu {
                display: block !important;
                /*animation: fadeIn 0.3s;*/
                animation: fadeIn 0.2s ease-in-out both;
            }

            &.open > .navigation-button-dropdown {
                background: #810050 !important;
                color: white !important;
            }

            a.navigate-button {
                display: block;
                float: left;
                width: 88%;
                height: 50px;
                color: white;
                text-align: center;
                border-radius: 5px;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                font-size: 16px;
                font-weight: 700 !important;
                font-family: 'Raleway', sans-serif;
                background-color: $secondary-color;
                -webkit-appearance: none;
                line-height: 50px;
                transition: color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),box-shadow .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),background-color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
                border: none;

                &:hover {
                    background-color: #810050;
                }

                &:after {
                    display: block;
                    content: '';
                    background-color: #fff;
                    position: absolute;
                    width: 2px;
                    height: 50px;
                    top: 0px;
                    left: 88%;
                    z-index: 9998;
                }
            }

            button.navigation-button-dropdown {
                position: relative;
                float: left;
                /*width: 50px;*/
                width: 12%;
                height: 50px;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
                background-color: $secondary-color;
                -webkit-appearance: none;
                border-left-width: 4px !important;
                cursor: pointer;
                color: white;
                transition: color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),box-shadow .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),background-color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
                border: none;
                margin: 0;
                outline: none;

                &:hover {
                    background-color: #810050;
                }

                &:active {
                    background: #ffffff;
                    color: $secondary-color;
                }

                &:after {
                    display: inline-block;
                    content: '';
                    margin-left: 2px;
                    vertical-align: 0;
                    border-top: 0.5em solid;
                    border-right: 0.5em solid transparent;
                    border-bottom: 0;
                    border-left: 0.5em solid transparent;
                }
            }

            ul.navigation-button-dropdown-menu {
                position: absolute;
                top: 50px;
                right: 0;
                z-index: 1000;
                display: none;
                float: left;
                min-width: 160px;
                padding: 0;
                margin: 2px 0 0;
                overflow: hidden;
                font-size: 14px;
                list-style: none;
                background-color: #f5f5f5;
                background-clip: padding-box;
                border: 1px solid #e9e9e9;
                border-radius: 5px;
                box-shadow: 0 0 #000000, 0 0 #000000, 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1);

                li a {
                    display: block;
                    padding: 10px 20px;
                    clear: both;
                    font-weight: bold;
                    font-family: 'Raleway', sans-serif;
                    color: #342C0C;
                    text-decoration: none;

                    &:hover {
                        background: #e9e9e9;
                    }
                }
            }
        }

        div.station-under-construction {
            font-family: 'Raleway', sans-serif;
            margin-top: 10px;

            span {
                display: block;
                text-align: center;
                font-size: 13px;
                font-weight: bold;
                text-transform: uppercase;
                padding: 8px;
                color: #ffffff;
                background-color: #f89e23;
                border-radius: 0.5rem;
            }
        }

        label.info-label {
            font-family: 'Raleway', sans-serif;
            text-transform: uppercase;
            font-weight: bold;
            color: black;
            margin-top: 5px;
            margin-bottom: 5px;

            &.first-label {
                margin-top: 15px;
            }
        }

        div.info-container {
            color: #666666;
            font-size: 16px;
            line-height: 20px;
            font-family: 'Raleway', sans-serif;
            margin-bottom: 5px;

            span {
                display: block;
            }

            button.copy-btn {
                margin-left: 5px;
                outline: none;
                cursor: pointer;
                opacity: .6;
                transition: all .1s ease;

                &:hover {
                    transform: translateY(-3px);
                    opacity: 1;
                }

                img {
                    width: 20px;
                }
            }

            span.address-block {
                margin-bottom: 5px;

                span.address-block-copy {
                    position: relative;
                    display: inline-block;

                    span.tooltip-address {
                        position: absolute;
                        top: 25px;
                        left: -35px;
                        background: #373737;
                        padding: 5px 10px;
                        display: flex !important;
                        justify-content: center;
                        color: #fff;
                        font-size: 13px;
                        border-radius: 4px;
                        opacity: 0;

                        &.appear {
                            animation: appear 1s ease;
                        }
                    }
                }
            }

            span.gps-block {
                margin-bottom: 5px;

                span.gps-block-copy {
                    position: relative;
                    display: inline-block;

                    span.tooltip-gps {
                        position: absolute;
                        top: 25px;
                        left: -35px;
                        background: #373737;
                        padding: 5px 10px;
                        display: flex !important;
                        justify-content: center;
                        color: #fff;
                        font-size: 13px;
                        border-radius: 4px;
                        opacity: 0;

                        &.appear {
                            animation: appear 1s ease;
                        }
                    }
                }
            }

            span.recommended-card-block {
                margin-bottom: 5px;

                span {
                    /*display: inline-block;*/
                    display: inline;

                    img {
                        width: 30px;
                        margin-top: -4px;
                    }

                    span.provider {
                        display: inline;
                        /*display: inline-block;*/
                        text-align: center;
                        font-size: 12px;
                        font-weight: bold;
                        text-transform: uppercase;
                        white-space: nowrap;
                        padding: 3px 6px;
                        color: #ffffff;
                        background-color: #C8017D;
                        border-radius: 0.5rem;
                    }

                    span.provider-cez {
                        background-color: #00A0DF;
                    }

                    span.provider-combination {
                        display: inline;
                    }

                    span.provider-info {
                        text-transform: none;
                        font-weight: normal;
                    }
                }

                span.info-icon {
                    display: inline-block !important;
                    cursor: pointer;
                    margin-left: 0.25rem;
                    opacity: .6;
                    transition: all .1s ease;

                    &:hover {
                        transform: translateY(-3px);
                        opacity: 1;
                    }
                }

                img.info-icon {
                    width: 18px !important;
                    margin-top: 0px !important;
                }
            }

            span.station-identification {
                margin-bottom: 5px;

                span.identification {
                    display: inline;
                    color: $secondary-color;
                    font-weight: bold;
                }
            }

            span.contact-item {
                font-size: 14px;
                margin-bottom: 3px;
            }
        }

        table.info-container-table {
            margin-bottom: 5px;
        }

        a.email-address {
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            color: $secondary-color;
            font-size: 14px;
        }

        li.phone-list {
            list-style: none;
        }

        a.phone-number {
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            color: $secondary-color;
            font-size: 14px;
        }

        a.operator {
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            color: $secondary-color;
            font-size: 14px;
        }

        span.station-info-text {
            display: block;
            text-align: center;
            margin-top: 10px;
            font-family: 'Raleway', sans-serif;
            font-size: 12px;
            color: #666666;

            a {
                font-family: 'Raleway', sans-serif;
                color: $secondary-color;
            }
        }

        div.connectors-block {
            text-align: left;
        }

        div.connectors {
            vertical-align: top;
            display: inline-block;
            text-align: center;
            width: 31%;
            background-color: #F9F9FA;
            border-radius: 4px;
            margin-bottom: 3px;
            padding: 5px;

            &:not(:last-child) {
                margin-right: 3px;
            }

            img.connectors-icon {
                width: 35px;
                height: 45px;
                margin-top: 3px;
                margin-bottom: 5px;
            }

            span.connectors-name {
                display: block;
                font-family: 'Raleway', sans-serif;
                font-size: 12px;
                color: #666666;
            }

            span.connectors-name-sub {
                display: block;
                font-family: 'Raleway', sans-serif;
                font-size: 12px;
                color: #666666;
            }
        }
    }

    @keyframes appear {
        0% {
            opacity: 0;
        }

        20% {
            transform: translateY(10px);
            opacity: 1;
        }

        80% {
            transform: translateY(0px);
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    @-webkit-keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div#charging-station-page {
            /*position: fixed;*/
            overflow: auto;
            right: 0px;
            left: 0px;
            top: 0px;
            bottom: 0px;
            box-shadow: none;
            border-radius: 0;
            z-index: 99999;

            h2.charging-station-title {
                color: #342C0C;
                width: 80%;
                font-size: 18px;
                line-height: 20px;
                margin: 10px auto 15px;
            }

            div.charging-station-image {
                position: relative;

                img.station-image {
                    width: 100%;
                    height: 170px;
                    object-fit: cover;
                    object-position: center;
                }
            }

            div.station-under-construction {
                span {
                    font-size: 10px;
                }
            }

            span.navigate-button-group {
                a.navigate-button {
                    width: 85%;

                    &:after {
                        left: 85%;
                    }
                }

                button.navigation-button-dropdown {
                    width: 15%;
                }
            }

            div.info-container {
                font-size: 15px;
                line-height: 20px;

                span.recommended-card-block {
                    span {
                        display: inline-block;
                    }
                }
            }
        }
    }

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {

    }

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {

    }

    @media screen and (min-width: 40em) and (max-height: 74.9375em) {
        div#charging-station-page {
            overflow: visible;
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 760px;
        }
    }

    @media screen and (min-width: 40em) and (max-height: 53.75em) {
        div#charging-station-page {
            overflow: visible;
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 670px;
        }
    }

    @media screen and (min-width: 40em) and (max-height: 48.125em) {
        div#charging-station-page {
            overflow: visible;
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 570px;
        }
    }

    @media screen and (min-width: 40em) and (max-height: 41.875em) {
        div#charging-station-page {
            overflow: visible;
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 500px;
        }
    }
</style>

<template>
    <div id="charging-station-page">
        <div class="close-block">
            <a v-on:click="leaveChargingStation()" class="close-block-button">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </a>
        </div>

        <loader v-show="chargingStationLoadStatus == 0 || chargingStationLoadStatus == 1" :width="100" :height="100"></loader>

        <h2 class="charging-station-title" v-if="chargingStationLoadStatus == 2">{{ chargingStation.name }}</h2>

        <div class="grid-x charging-station-image" v-if="chargingStationLoadStatus == 2 && chargingStation.images.length">
            <CoolLightBox :items="[chargingStation.images[0]['imageUrl']]" :index="index" :effect="'fade'" :slideshow="false" :gallery="false" :showCloseButton="true" :disableZoom="true" @close="index = null">
                <template v-slot:close>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"></path>
                    </svg>
                </template>
            </CoolLightBox>

            <img v-bind:src="chargingStation.images[0]['imageUrl']" class="station-image" />

            <div class="maximize">
                <span class="show-icon" @click="index = 0"><img src="/img/icons/maximize.png" title="Maximize"></span>
            </div>

            <div class="features">
                <span class="source">{{ $t('detail.imageSource') }} {{ chargingStation.provider }}</span>
            </div>
        </div>

        <div class="grid-x" v-if="chargingStationLoadStatus == 2">
            <div class="large-12 medium-12 small-12 cell">
                <span class="navigate-button-group" v-bind:class="{open: navigationDropdownOpen}">
                    <a :href="navigationMapLink(chargingStation.latitude, chargingStation.longitude)" target="_blank" class="navigate-button">
                        {{ $t('detail.navigateToChargingStationButton') }}
                    </a>

                    <button class="navigation-button-dropdown" @click.stop="navigationDropdownOpen = true" v-on:click="showNavigationDropdown"></button>

                    <ul class="navigation-button-dropdown-menu" v-click-outside="hideNavigationDropdown">
                        <li>
                            <a @click.prevent="navigationMapOpen('waze', chargingStation.latitude, chargingStation.longitude)">Waze</a>
                        </li>
                        <li v-if="isAppleDevice()">
                            <a @click.prevent="navigationMapOpen('apple-maps', chargingStation.latitude, chargingStation.longitude)">Apple Maps</a>
                        </li>
                        <li>
                            <a @click.prevent="navigationMapOpen('google-maps', chargingStation.latitude, chargingStation.longitude)">Google Maps</a>
                        </li>
                    </ul>
                </span>
            </div>
        </div>

        <div class="grid-x" v-if="chargingStationLoadStatus == 2 && chargingStation.status == 'under_construction'">
            <div class="large-12 medium-12 small-12 cell">
                <div class="station-under-construction">
                    <span>{{ $t('detail.stationUnderConstruction') }}</span>
                </div>
            </div>
        </div>

        <div class="grid-x" v-if="chargingStationLoadStatus == 2">
            <div class="large-12 medium-12 small-12 cell">
                <label class="info-label first-label">{{ $t('detail.infoAboutChargingStation') }}</label>

                <div class="info-container">
                    <span class="address-block">
                        {{ chargingStation.street }}{{ chargingStation.number ? ' ' + chargingStation.number : '' }}, {{ chargingStation.city }}
                        <span class="address-block-copy">
                            <span class="tooltip-address">{{ $t('detail.tooltipCopied') }}</span>
                            <button class="copy-btn" @click="copyAddressToClipBoard(chargingStation.street + (chargingStation.number ? ' ' + chargingStation.number : '') + ', ' + chargingStation.city)">
                                <img src="/img/icons/copy-icon.svg" v-bind:title="$t('detail.buttonCopyAddress')">
                            </button>
                        </span>
                    </span>

                    <span class="gps-block">
                        GPS: {{ parseFloat(chargingStation.latitude).toFixed(5) }}, {{ parseFloat(chargingStation.longitude).toFixed(5) }}
                        <span class="gps-block-copy">
                            <span class="tooltip-gps">{{ $t('detail.tooltipCopied') }}</span>
                            <button class="copy-btn" @click="copyGpsToClipBoard(chargingStation.latitude + ', ' + chargingStation.longitude)">
                                <img src="/img/icons/copy-icon.svg" v-bind:title="$t('detail.buttonCopyGps')">
                            </button>
                        </span>
                    </span>

                    <span class="recommended-card-block">
                        {{ $t('detail.recommendedCard') }}:

                        <span v-if="chargingStation.provider == 'ČEZ'">
                            <span class="provider provider-cez">ČEZ <span class="provider-info">{{ $t('detail.recommendedCardProviderInfo') }}</span></span><span class="info-icon" v-on:click="showRecommendedChargingCardModal()"><img src="/img/info-icon.svg" class="info-icon"></span>
                        </span>

                        <span v-if="chargingStation.provider == 'PRE' || chargingStation.provider == 'fDrive' || chargingStation.provider == 'ZSE' || chargingStation.provider == 'CLE'">
                            <span v-if="chargingStation.cpo_id == 'CZ*EON'" class="provider-combination">{{ $t('detail.recommendedCardProviderInfoUpTo') }} 99 kW <span class="provider provider-cez">ČEZ <span class="provider-info">{{ $t('detail.recommendedCardProviderInfo') }}</span></span>, {{ $t('detail.recommendedCardProviderInfoHigherPower') }} <span class="provider">PRE <span class="provider-info">{{ $t('detail.recommendedCardProviderInfo') }}</span></span></span>
                            <span v-else class="provider">PRE <span class="provider-info">{{ $t('detail.recommendedCardProviderInfo') }}</span></span>
                            <span class="info-icon" v-on:click="showRecommendedChargingCardModal()"><img src="/img/info-icon.svg" class="info-icon"></span>
                        </span>
                    </span>

                    <span class="station-identification" v-if="chargingStation.custom_id">
                        {{ $t('detail.stationIdentification') }}: <span class="identification">{{ chargingStation.custom_id }}</span>
                    </span>
                </div>
            </div>
        </div>

        <div class="grid-x" v-if="chargingStationLoadStatus == 2">
            <div class="large-12 medium-12 small-12 cell">
                <label class="info-label" v-if="chargingStation.connectors.length">{{ $t('detail.connectors') }}</label>

                <div class="connectors-block">
                    <div v-for="(connector, index) in uniqueConnectors" :key="index" class="connectors">
                        <img v-if="connector.standard == 'MENNEKES_TYPE_2'" v-bind:src="'/img/connectors/mennekes.svg'" class="connectors-icon" />
                        <img v-if="connector.standard == 'CHADEMO'" v-bind:src="'/img/connectors/chademo.svg'" class="connectors-icon" />
                        <img v-if="connector.standard == 'CCS_COMBO'" v-bind:src="'/img/connectors/combo.svg'" class="connectors-icon" />
                        <img v-if="connector.standard == 'TYPE_1_CONNECTOR_CABLE_ATTACHED'" v-bind:src="'/img/connectors/type1.svg'" class="connectors-icon" />
                        <img v-if="connector.standard == 'TYPE_F_SCHUKO' || connector.standard == 'TYPE F SCHUKO'" v-bind:src="'/img/connectors/schuko.svg'" class="connectors-icon" />

                        <span v-if="connector.standard == 'MENNEKES_TYPE_2'" class="connectors-name">{{ connector.count > 1 ? connector.count + 'x ' : null }}Mennekes<br />({{connector.power_output}} kW)</span>
                        <span v-if="connector.standard == 'CHADEMO'" class="connectors-name">{{ connector.count > 1 ? connector.count + 'x ' : null }}CHAdeMO<br />({{connector.power_output}} kW)</span>
                        <span v-if="connector.standard == 'CCS_COMBO'" class="connectors-name">{{ connector.count > 1 ? connector.count + 'x ' : null }}CCS Combo<br />({{connector.power_output}} kW)</span>
                        <span v-if="connector.standard == 'TYPE_1_CONNECTOR_CABLE_ATTACHED'" class="connectors-name">{{ connector.count > 1 ? connector.count + 'x ' : null }}Type 1<br />({{connector.power_output}} kW)</span>
                        <span v-if="connector.standard == 'TYPE_F_SCHUKO' || connector.standard == 'TYPE F SCHUKO'" class="connectors-name">{{ connector.count > 1 ? connector.count + 'x ' : null }}Schuko<br />({{connector.power_output}} kW)</span>
                    </div>
                </div>

                <label class="info-label">{{ $t('detail.contact') }}</label>
                <div class="info-container">
                    <span class="contact-item" v-if="chargingStation.email">{{ $t('detail.contactEmail') }}: <a class="email-address" v-bind:href="'mailto:' + chargingStation.email">{{ chargingStation.email }}</a></span>
                    <span class="contact-item"v-if="chargingStation.phone">{{ $t('detail.contactPhone') }}: <a class="phone-number" v-bind:href="'tel:' + chargingStation.phone.trim()">{{ formatPhone(chargingStation.phone) }}</a></span>
                    <span class="contact-item" v-if="chargingStation.cpo_id">{{ $t('detail.operator') }}: <a class="operator" href="#">{{ chargingStation.cpo_id }}</a></span>
                </div>

                <span class="station-info-text" v-html="$t('detail.stationAdditionalInformation')"></span>
            </div>
        </div>

        <charging-station-recommended-card-modal></charging-station-recommended-card-modal>
    </div>
</template>

<script>
    import { EventBus } from '../event-bus.js';
    import Loader from "../components/global/Loader";
    import Geocode from "../api/geocode";
    import ChargingStationRecommendedCardModal from '../components/global/ChargingStationRecommendedCardModal.vue';
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

    export default {
        components: {
            Loader,
            ChargingStationRecommendedCardModal,
            CoolLightBox
        },

        data() {
            return {
                index: null,
                navigationDropdownOpen: false
            }
        },

        created() {
            this.$store.dispatch('toggleShowFilters', { showFilters : false });

            this.$store.dispatch('changeServicesView', 'map');

            this.loadChargingStation();
        },

        watch: {
            '$route.params.slug': function() {
                this.$store.dispatch('loadChargingStation', {
                    slug: this.$route.params.slug
                });
            },

            '$route' (to, from) {
                //document.title = this.chargingStation.name;
            },

            'chargingStationLoadStatus': function() {
                if (this.chargingStationLoadStatus == 2) {
                    EventBus.$emit('charging-station-selected', {
                        id: this.chargingStation.id,
                        lat: parseFloat(this.chargingStation.latitude),
                        lng: parseFloat(this.chargingStation.longitude)
                    });

                    document.title = this.chargingStation.name + ' | Drivalia';
                }

                if (this.chargingStationLoadStatus == 3) {
                    this.$store.dispatch('flashMessageShow', {
                        type: 'error',
                        message: this.$t('detail.errorMessageChargingStationNotFound')
                    }, {
                        root: true
                    });

                    this.$router.push({ name: 'charging-stations' });
                }
            }
        },

        computed: {
            clientLocation() {
                return this.$store.getters.getClientLocation;
            },

            chargingStationLoadStatus() {
                return this.$store.getters.getChargingStationLoadStatus;
            },

            chargingStation() {
                return this.$store.getters.getChargingStation;
            },

            uniqueConnectors() {
                var menn_43 = 0;
                var menn_22 = 0;
                var menn_11 = 0;
                var menn_7 = 0;

                var ccs_350 = 0;
                var ccs_300 = 0;
                var ccs_225 = 0;
                var ccs_200 = 0;
                var ccs_180 = 0;
                var ccs_175 = 0;
                var ccs_150 = 0;
                var ccs_100 = 0;
                var ccs_75 = 0;
                var ccs_50 = 0;
                var ccs_22 = 0;
                var ccs_20 = 0;
                var ccs_16 = 0;
                var ccs_11 = 0;

                var ch_200 = 0;
                var ch_150 = 0;
                var ch_100 = 0;
                var ch_75 = 0;
                var ch_60 = 0;
                var ch_50 = 0;
                var ch_22 = 0;
                var ch_20 = 0;
                var ch_11 = 0;

                const chargingStationsUniqueConnectors = this.chargingStation.connectors.reduce((p,c) => {
                    if (c.standard == 'CCS_COMBO' || c.standard == 'CHADEMO' || c.standard == 'MENNEKES_TYPE_2' || c.standard == 'TYPE_1_CONNECTOR_CABLE_ATTACHED' || c.standard == 'TYPE_F_SCHUKO' || c.standard == 'TYPE F SCHUKO') {
                        if (c.standard == 'CCS_COMBO') {
                            if (c.power_output == 350) {
                                ccs_350++;
                                var count = ccs_350;
                            }

                            if (c.power_output == 300) {
                                ccs_300++;
                                var count = ccs_300;
                            }

                            if (c.power_output == 225) {
                                ccs_225++;
                                var count = ccs_225;
                            }

                            if (c.power_output == 200) {
                                ccs_200++;
                                var count = ccs_200;
                            }

                            if (c.power_output == 180) {
                                ccs_180++;
                                var count = ccs_180;
                            }

                            if (c.power_output == 175) {
                                ccs_175++;
                                var count = ccs_175;
                            }

                            if (c.power_output == 150) {
                                ccs_150++;
                                var count = ccs_150;
                            }

                            if (c.power_output == 100) {
                                ccs_100++;
                                var count = ccs_100;
                            }

                            if (c.power_output == 75) {
                                ccs_75++;
                                var count = ccs_75;
                            }

                            if (c.power_output == 50) {
                                ccs_50++;
                                var count = ccs_50;
                            }

                            if (c.power_output == 22) {
                                ccs_22++;
                                var count = ccs_22;
                            }

                            if (c.power_output == 20) {
                                ccs_20++;
                                var count = ccs_20;
                            }

                            if (c.power_output == 16) {
                                ccs_16++;
                                var count = ccs_16;
                            }

                            if (c.power_output == 11) {
                                ccs_11++;
                                var count = ccs_11;
                            }
                        }

                        if (c.standard == 'CHADEMO') {
                            if (c.power_output == 200) {
                                ch_200++;
                                var count = ch_200;
                            }

                            if (c.power_output == 150) {
                                ch_150++;
                                var count = ch_150;
                            }

                            if (c.power_output == 100) {
                                ch_100++;
                                var count = ch_100;
                            }

                            if (c.power_output == 75) {
                                ch_75++;
                                var count = ch_75;
                            }

                            if (c.power_output == 60) {
                                ch_60++;
                                var count = ch_60;
                            }

                            if (c.power_output == 50) {
                                ch_50++;
                                var count = ch_50;
                            }

                            if (c.power_output == 22) {
                                ch_22++;
                                var count = ch_22;
                            }

                            if (c.power_output == 20) {
                                ch_20++;
                                var count = ch_20;
                            }

                            if (c.power_output == 11) {
                                ch_11++;
                                var count = ch_11;
                            }
                        }

                        if (c.standard == 'MENNEKES_TYPE_2') {
                            if (c.power_output == 43) {
                                menn_43++;
                                var count = menn_43;
                            }

                            if (c.power_output == 22) {
                                menn_22++;
                                var count = menn_22;
                            }

                            if (c.power_output == 11) {
                                menn_11++;
                                var count = menn_11;
                            }

                            if (c.power_output == 7) {
                                menn_7++;
                                var count = menn_7;
                            }
                        }

                        p[c.standard + '_' + c.power_output] = c
                        p[c.standard + '_' + c.power_output]['count'] = count
                    }

                    return p
                }, {})

                //console.log(Object.values(chargingStationsUniqueConnectors).sort((a,b) => a.standard.localeCompare(b.standard)));

                return Object.values(chargingStationsUniqueConnectors).sort(((a,b) => b.power_output - a.power_output));
            }
        },

        directives: {
            clickOutside: {
                bind: function (el, binding, vnode) {
                    el.eventSetDrag = function () {
                        el.setAttribute('data-dragging', 'yes');
                    }
                    el.eventClearDrag = function () {
                        el.removeAttribute('data-dragging');
                    }
                    el.eventOnClick = function (event) {
                        var dragging = el.getAttribute('data-dragging');
                        if (!(el == event.target || el.contains(event.target)) && !dragging) {
                            vnode.context[binding.expression](event);
                        }
                    };
                    document.addEventListener('touchstart', el.eventClearDrag);
                    document.addEventListener('touchmove', el.eventSetDrag);
                    document.addEventListener('click', el.eventOnClick);
                    document.addEventListener('touchend', el.eventOnClick);
                },
                unbind: function (el) {
                    document.removeEventListener('touchstart', el.eventClearDrag);
                    document.removeEventListener('touchmove', el.eventSetDrag);
                    document.removeEventListener('click', el.eventOnClick);
                    document.removeEventListener('touchend', el.eventOnClick);
                    el.removeAttribute('data-dragging');
                },
            },
        },

        methods: {
            setClientLocation(position) {
                Geocode.getCountryCodeFromPosition(position)
                    .then((response) => {
                        if (response != 'CZ') {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: 50.08804, longitude: 14.42076 } })
                        } else {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: position.coords.latitude, longitude: position.coords.longitude } })
                        }

                        this.loadChargingStation();
                    })
                    .catch((error) => {
                        console.log(error)
                    });
            },

            loadChargingStation() {
                this.$store.dispatch('loadChargingStation', {
                    slug: this.$route.params.slug
                });
            },

            leaveChargingStation() {
                this.$router.push({ name: 'charging-stations' });
            },

            formatPhone(value) {
                return value.trim().replace(/(\d{3})(\d{3})(\d{3})(\d{3})/,"$1 $2 $3 $4");
            },

            showNavigationDropdown() {
                var splitBtn = $('.navigate-button-group');

                if (!splitBtn.hasClass('open')) {
                    //splitBtn.addClass('open');
                } else {
                    this.navigationDropdownOpen = false;
                    //splitBtn.removeClass('open');
                }

                /*
                $('.navigate-button-group').click(function(event) {
                    event.stopPropagation();
                });
                */
            },

            hideNavigationDropdown() {
                this.navigationDropdownOpen = false;
            },

            navigationMapOpen(application, latitude, longitude) {
                if (application == 'waze') {
                    window.location = 'waze://?ll=' + latitude +',' + longitude + '&navigate=yes';

                    setTimeout(() => {
                        window.open("https://waze.com/ul?ll=" + latitude + "," + longitude + "&navigate=yes", "_blank").focus();
                    }, 1000);
                } else if (application == 'apple-maps') {
                    window.location = 'maps://?daddr=' + latitude +',' + longitude;

                    setTimeout(() => {
                        window.open("http://maps.apple.com/maps?daddr=" + latitude + "," + longitude, "_blank").focus();
                    }, 1000);
                } else if (application == 'google-maps') {
                    window.location = 'comgooglemaps://?daddr=' + latitude +',' + longitude;

                    setTimeout(() => {
                        window.open("https://www.google.com/maps/search/?api=1&query=" + latitude + "," + longitude, "_blank").focus();
                    }, 1000);
                }
            },

            navigationMapLink(latitude, longitude) {
                if ((navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPod") != -1) || (navigator.platform.indexOf("iPad") != -1)) {
                    return 'http://maps.apple.com/maps?daddr='+ latitude + ',' + longitude;
                } else {
                    return 'https://www.google.com/maps/search/?api=1&query=' + latitude + ',' + longitude;
                }
            },

            copyAddressToClipBoard(text) {
                $('.tooltip-address').addClass('appear').delay(1000).queue(function() {
                    $('.tooltip-address').removeClass('appear');
                    $('.tooltip-address').dequeue();
                });

                navigator.clipboard.writeText(text);
            },

            copyGpsToClipBoard(text) {
                $('.tooltip-gps').addClass('appear').delay(1000).queue(function() {
                    $('.tooltip-gps').removeClass('appear');
                    $('.tooltip-gps').dequeue();
                });

                navigator.clipboard.writeText(text);
            },

            showRecommendedChargingCardModal() {
                EventBus.$emit('prompt-recommended-charging-card');
            },

            isAppleDevice() {
                if ((navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPod") != -1) || (navigator.platform.indexOf("iPad") != -1) || (navigator.platform.indexOf("MacIntel") != -1)) {
                    return true;
                } else {
                    return false;
                }
            },
        }
    }
</script>
